import { render, staticRenderFns } from "./MoveVehicleToNewGroup.vue?vue&type=template&id=18f34566&scoped=true"
import script from "./MoveVehicleToNewGroup.vue?vue&type=script&lang=js"
export * from "./MoveVehicleToNewGroup.vue?vue&type=script&lang=js"
import style0 from "./MoveVehicleToNewGroup.vue?vue&type=style&index=0&id=18f34566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f34566",
  null
  
)

export default component.exports